import PropTypes from 'prop-types'

// Internal Components
import LazyImage from '../LazyImage/LazyImage'
import RichTextBlock from '../RichTextBlock/RichTextBlock'
import Caption from '../Caption/Caption'

const FigurePortrait = ({ figureImage, figureCaption, figureAlignment, figureWysiwyg }) => {
  return (
    <div className={`FigurePortrait ${figureAlignment === 'right' ? 'FigurePortrait--wrapRight' : ''}`}>
      {figureImage && (
        <div className="FigurePortrait-graphic">
          {figureImage && (
            <div className="FigurePortrait-image">
              <LazyImage {...figureImage[0]} modifiers={['FigurePortrait-lazyImage']} />
            </div>
          )}
          {figureCaption && (
            <Caption
              iconId="icon-image"
              html={figureCaption}
              modifiers={[`${figureAlignment === 'right' ? 'Caption--wrapRight' : ''}`]}
            />
          )}
        </div>
      )}
      {figureWysiwyg && (
        <div className="FigurePortrait-richTextBlock">
          <RichTextBlock content={figureWysiwyg} />
        </div>
      )}
    </div>
  )
}

export default FigurePortrait

FigurePortrait.propTypes = {
  id: PropTypes.string.isRequired,
  figureImage: PropTypes.array.isRequired,
  figureCaption: PropTypes.string,
  figureAlignment: PropTypes.string,
  figureWysiwyg: PropTypes.string
}
